export default {
    namespaced: true,
    state: {
        pagina:   'FONDOS SOCIALES',
        url:      'https://iberopa.com/_abk/exec.php',
        url_img:  'https://iberopa.com/_abk/lib/imagendb.php',
        url_tmp:  'https://iberopa.com/_abk/tmp/',
        urlA:     'http://fondos-sociales.com/__a/',
        url_tmpW: 'http://fondos-sociales.com/tmp/',

        abk_url: {
            user:   'abakan',
            salida: 'json',
            clase:  'adm/vc/fondos',
            fnt:    '',
            args:   [],
        },

    },
    mutations: {
    },
    actions: {
    },
    getters: {
    }
}